import * as React from "react"
import { type Transaction, TransactionSourceType } from "@digits-graphql/frontend/graphql-bearer"
import { isProviderTypeDeletable } from "src/frontend/components/OS/Applications/Shared/Accounting/helpers/canDeleteTransaction"

export function useIsBulkDisabled(transactions: Transaction[]) {
  return React.useMemo(() => {
    const allInstitutionSources = Array.from(transactions)
      .map((transaction) => transaction.sources)
      .flat()
      .filter((source) => source.type === TransactionSourceType.Institution)
      .map((source) => source.name)

    const invalidProviderTypes = new Set(
      transactions
        .map((transaction) => transaction.providerTypes)
        .flat()
        .filter((providerType) => !isProviderTypeDeletable(providerType))
    )

    const sources = new Set<string>(allInstitutionSources)

    const hasTransactionWithMultipleSplit = Array.from(transactions).some(
      (transaction) => !transaction.splitCategory?.id
    )

    return {
      sourceString: Array.from(sources).join(", "),
      areTransactionsDeletable: invalidProviderTypes.size === 0,
      hasQuickBooksTransactionsSelected: sources.has("QuickBooks"),
      hasTransactionWithMultipleSplit,
    }
  }, [transactions])
}
